import { memoizeFunction } from '@agilepoint/utils-common';

export const getUserProfilePayloadDefault = memoizeFunction((userName: string = '') => ({
    displayName: userName,
    userName: userName,
    locale: 'en-US',
    email: '',
    profileImage: ''
}));
